export const LEGAL_ENTITY_AUTHORISATION_CONFIRMATION =
  "I confirm that I am authorised to complete this application to update the Legal Entity contact details and I declare that the information I have supplied in this application is, to the best of my knowledge and belief, true and correct.";
export const PREMISES_AUTHORISATION_CONFIRMATION =
  "I confirm that I am authorised to complete this application to update the Premises contact details and I declare that the information I have supplied in this application is, to the best of my knowledge and belief, true and correct.";

export const INFORMATION_ACCURACY_CONFIRMATION =
  "I confirm this information is accurate";
export const INDIVIDUAL_DETAILS =
  "I confirm that the requested updates to my information above are true and correct";
